import React, { createContext, useContext, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCategories } from "@/lib/api";
import { CATEGORIES } from "@/lib/categories";

const CategoriesContext = createContext(null);

export const CategoriesProvider = ({ children }) => {
  const { data } = useQuery({ queryKey: ["categories"], queryFn: fetchCategories, staleTime: 60000 });
  const categories = data && data.length ? data : CATEGORIES;

  const label = useCallback(
    (slug, lang) => {
      const c = categories.find((x) => x.slug === slug);
      return c ? (lang === "ro" ? c.ro : c.en) : slug;
    },
    [categories]
  );

  return (
    <CategoriesContext.Provider value={{ categories, label }}>
      {children}
    </CategoriesContext.Provider>
  );
};

export const useCategories = () => useContext(CategoriesContext) || { categories: CATEGORIES, label: (s) => s };
